export default "__VITE_ASSET__DGrFdmey__"